<section class="operations-page operations-detail">
    <app-operations-back-link
            routerLink="/operations/transactions"
            [queryParams]="backLinkQueryParams"
            label="← Back to transactions"
    ></app-operations-back-link>

    <div class="operations-page__card" *ngIf="loading">
        <p class="operations-page__loading">Loading transaction…</p>
    </div>

    <div *ngIf="!loading && !transaction" class="operations-page__card">
        <p class="operations-page__empty">
            {{ loadError ? 'Unable to load this transaction. Try again from the list.' : 'Transaction not found.' }}
        </p>
    </div>

    <ng-container *ngIf="!loading && transaction as tx">
        <header class="operations-page__header">
            <div>
                <h2 class="operations-page__title">{{ tx.transaction_id }}</h2>
                <p class="operations-page__lead">Operations diagnostics for this vehicle transaction lifecycle.</p>
            </div>
            <div class="operations-status-badges">
                <app-transaction-status-badge [status]="tx.status"></app-transaction-status-badge>
                <app-operational-attention-badge [transaction]="tx"></app-operational-attention-badge>
            </div>
        </header>

        <section class="operations-page__card">
            <h3 class="operations-page__title">Transaction Summary</h3>
            <div class="operations-detail__summary">
                <app-inspection-outcome-badge
                        [outcome]="transactionView.getInspectionOutcome(tx)"
                ></app-inspection-outcome-badge>
            </div>
            <app-metadata-panel
                    [entries]="transactionView.buildTransactionSummaryEntries(tx)"
            ></app-metadata-panel>
        </section>

        <section class="operations-page__card">
            <h3 class="operations-page__title">Correlation</h3>
            <app-metadata-panel [entries]="transactionView.buildCorrelationEntries(tx)"></app-metadata-panel>
        </section>

        <section class="operations-page__card" *ngIf="transactionView.buildInspectionEntries(tx).length">
            <h3 class="operations-page__title">Inspection</h3>
            <app-metadata-panel [entries]="transactionView.buildInspectionEntries(tx)"></app-metadata-panel>
        </section>

        <section class="operations-page__card">
            <h3 class="operations-page__title">Timeline</h3>
            <app-metadata-panel [entries]="transactionView.buildTimingEntries(tx)"></app-metadata-panel>
            <app-activity-timeline
                    class="operations-detail__activity-timeline"
                    [activities]="timelineActivities"
                    [currentIndex]="timelineCurrentIndex"
            ></app-activity-timeline>
        </section>

        <section class="operations-page__card" *ngIf="analyticsFacts.length">
            <h3 class="operations-page__title">Analytics facts</h3>
            <div class="operations-facts">
                <div class="operations-fact-item" *ngFor="let fact of analyticsFacts">
                    <span class="operations-fact-item__label">{{ fact.label || fact.output_fact }}</span>
                    <app-analytics-fact-renderer [fact]="fact"></app-analytics-fact-renderer>
                </div>
            </div>
        </section>

        <section class="operations-page__card" *ngIf="relatedRecordLinks.length">
            <h3 class="operations-page__title">Related Records</h3>
            <div class="operations-links">
                <div class="operations-links__item" *ngFor="let record of relatedRecordLinks">
                    <div>
                        <strong>{{ record.label }}</strong>
                        <span>{{ record.description }}</span>
                    </div>
                    <a class="operations-table__link"
                       [routerLink]="record.routerLink"
                       [queryParams]="record.queryParams || null">
                        View
                    </a>
                </div>
            </div>
        </section>
    </ng-container>
</section>
